import React from "react";
import { Link } from "react-router-dom";
import MainInput from "../Elements/MainInput/MainInput";
import LinkButton from "../Elements/LinkButton/LinkButton";
import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";
import ErrorMessage from "../Elements/ErrorMessage/ErrorMessage";
import Checkbox from "../Elements/Checkbox/Checkbox";
import GoogleAuthButton from "./GoogleAuthButton";
import AppleAuthButton from "./AppleAuthButton";
import FacebookAuthButton from "./FacebookAuthButton";

const AuthRegisterFlow = ({
  affiliateCode,
  verificationStage,
  userIcon,
  envelopeIcon,
  lockIcon,
  hashtag,
  eye,
  eyeOff,
  username,
  email,
  password,

  newsletterOptIn,
  onNewsletterOptInChange,
  verificationCode,
  showPassword,
  error,
  setError,
  onCloseTermsError,
  isMobile,
  onUsernameChange,
  onEmailChange,
  onPasswordChange,
  onVerificationCodeChange,
  onTogglePassword,
  onSendVerificationEmail,
  onVerifyRegistrationCode,
  onSwitchToLogin,
  onBackToForm,
  onCloseError,
}) => {
  if (verificationStage === "form") {
    return (
      <>
        <div className="input-with-icon">
          <img src={userIcon} className="input-icon" alt="user icon" />
          <MainInput
            placeholder="Full Name"
            autoComplete="off"
            value={username}
            onChange={(e) => {
              onUsernameChange(e.target.value);
              if (error) onCloseError();
            }}
          />
        </div>
        <div className="input-with-icon">
          <img src={envelopeIcon} className="input-icon" alt="email icon" />
          <MainInput
            placeholder="Email"
            type="email"
            autoComplete="new-email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
          />
        </div>
        <div className="input-with-icon">
          <img src={lockIcon} className="input-icon" alt="lock icon" />
          <MainInput
            placeholder="Password"
            type={showPassword ? "text" : "password"}
            autoComplete="new-password"
            value={password}
            onChange={(e) => onPasswordChange(e.target.value)}
          />
          {password.length > 0 && (
            <img
              src={showPassword ? eyeOff : eye}
              className="input-icon"
              alt={showPassword ? "hide password" : "show password"}
              onClick={onTogglePassword}
              style={{ right: "1.3rem", left: "auto", cursor: "pointer" }}
            />
          )}
        </div>

        <div className="auth-checkboxes">
          <Checkbox
            id="newsletter-optin"
            label={<>Subscribe to Telviora Updates & Exclusive travel deals</>}
            checked={newsletterOptIn}
            onChange={(e) => onNewsletterOptInChange(e.target.checked)}
          />
          <p className="summary-legal">
            By clicking "Register" you agree to{" "}
            <Link to="/terms" className="summary-legal__link">
              Terms & Conditions
            </Link>{" "}
            and{" "}
            <Link to="/privacy-policy" className="summary-legal__link">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
        <div className="auth-btn-group">
          <MainButton onClick={onSendVerificationEmail}>Register</MainButton>
          {isMobile && <SecondButton onClick={onSwitchToLogin}>Sign In</SecondButton>}
          <div className="social-login-section">
            <div className="social-divider">or continue with</div>
            <div className="social-login-cont">
              <GoogleAuthButton
                onError={(err) => setError(err.message)}
                affiliateCode={affiliateCode}
                newsletter={newsletterOptIn}
              />
              <FacebookAuthButton
                onError={(message) => setError(message)}
                affiliateCode={affiliateCode}
                newsletter={newsletterOptIn}
              />
              <AppleAuthButton
                onError={(err) => setError(err.message)}
                affiliateCode={affiliateCode}
                newsletter={newsletterOptIn}
              />
            </div>
          </div>
        </div>
        {error && <ErrorMessage message={error} onClose={onCloseError} />}
      </>
    );
  }
  // verificationStage === 'code'
  return (
    <>
      <LinkButton onClick={onBackToForm}>Change Email?</LinkButton>

      <p className="info-text">We’ve sent a code to your email. Enter it to finish registration:</p>
      <div className="input-with-icon">
        <img src={hashtag} className="input-icon" alt="code icon" />
        <MainInput
          placeholder="Verification Code"
          autoComplete="new-code"
          value={verificationCode}
          onChange={(e) => onVerificationCodeChange(e.target.value)}
        />
      </div>
      <MainButton className="single-btn-margin" onClick={onVerifyRegistrationCode}>
        Verify
      </MainButton>
      {error && <ErrorMessage message={error} onClose={onCloseError} />}
    </>
  );
};
export default AuthRegisterFlow;
